import { View } from 'react-native';

import { cn } from './cn';

/** Hairline rule in the border tone. */
export function Divider({ className }: { className?: string }) {
  return <View className={cn('h-px bg-border', className)} />;
}
